import { connect } from 'react-redux';

import { attSubPage } from 'decorators/subPage';
import TransferSubscription from './TransferSubscription';
import { transferAttSubscription } from 'api';
import { searchUsers } from 'actions/users';
import { getSearchUsers } from 'reducers';

const mapStateToProps = (state) => ({
  users: getSearchUsers(state),
  redirectUrl: (id) => `/att/subscriptions/${id}/view`,
  transferSub: transferAttSubscription,
  header: 'Transfer AT&T Subscription',
});

const mapDispatchToProps = () => ({
  searchUsers,
});

export default attSubPage(
  connect(mapStateToProps, mapDispatchToProps)(TransferSubscription),
);
